import cn from 'classnames';
import { FC } from 'react';

import type { NoteList } from '@/shared/api/protocol-ts/model/dto_scribe_catalog_pb';

import type { SurfaceLine } from '../lib';

import styles from './TemplateFieldRow.module.scss';
import { TemplateLineView } from './TemplateFieldView';

type LineRowProps = {
  line: SurfaceLine;
  lists: NoteList[];
};

// A line of a block template read before any note exists, as a field row.
export const TemplateLineRow: FC<LineRowProps> = ({ line, lists }) => (
  <div
    className={cn(styles.row, styles.lineRow, line.dormant && styles.dormant)}
    data-component="workspace-template-line"
    data-line-id={line.id}
    data-status={line.state}
  >
    <div className={styles.body}>
      <TemplateLineView line={line} mode="template" lists={lists} />
    </div>
  </div>
);
